<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs12>
          <h3 class="text-center">Add Lab Request</h3>
        </v-flex>
        <v-flex xs12 sm8 md6 class="pa-1">
          <v-card>
            <v-card-title class="primary pt-0 pb-0">
              <span role="button" title="Back to visit" @click="goTo('/clients/' + client.id + '/visits/' + visit.id)"><b v-html="client.name"></b> <em v-html="visit.date"></em></span>
              <v-spacer></v-spacer>
              <v-btn small text dark :href="'/clients/' + client.id + '/visits/' + visit.id" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id)" title="Back">
                <v-icon left>mdi-menu-left</v-icon>Cancel
              </v-btn>
            </v-card-title>
            <v-card-text>
              <add-lab-test :client="client" :visit="visit" :laboratories="laboratories" :store_link="store_link" :errors="errors"></add-lab-test><br>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card flat>
            <v-card-title class="primary py-0" @click="viewTests = !viewTests">
              Patient's Laboratory Test Request
              <v-spacer></v-spacer>
              <v-btn small icon class="primary" text dark>
                <v-icon>{{ viewTests ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="viewTests">
              <patient-lab-tests :client="client" :visit="visit"></patient-lab-tests>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const AddLabTest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/create')
  const PatientLabTests = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/index')

  export default {
    name: 'AddLabRequest',
    layout,
    props: [
      'client', 'visit', 'laboratories', 'store_link', 'errors'
    ],
    components: {
      AddLabTest,
      PatientLabTests
    },
    metaInfo () {
      return {
        title: 'Create Laboratory Request',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        data: '',
        viewTests: false
      }
    },
  }
</script>
<style>
   /**/
</style>
